import { AuthInitializer } from "@features/auth/presentation/components/AuthInitializer";
import AppRoutes from "@routes/AppRoutes";
import { ConfirmDialog } from "@shared/components/organisms/ConfirmDialog/ConfirmDialog";
import { ErrorBoundary } from "@shared/components/organisms/ErrorBoundary/ErrorBoundary";
import { Toaster } from "@shared/components/organisms/Toaster/Toaster";
import { queryClient } from "@shared/lib/queryClient";
import { WebSocketProvider } from "@shared/providers/WebSocketProvider";
import { QueryClientProvider } from "@tanstack/react-query";

function App() {
	return (
		<ErrorBoundary>
			<QueryClientProvider client={queryClient}>
				<WebSocketProvider>
					<AuthInitializer />
					<ErrorBoundary>
						<AppRoutes />
					</ErrorBoundary>
					<Toaster />
					<ConfirmDialog />
				</WebSocketProvider>
			</QueryClientProvider>
		</ErrorBoundary>
	);
}

export default App;
